
/// <amd-module name="Analytics/Shared/Powerbi/Utils/LocalCacheManager" />
export function getCachedState(key: string, cacheInvalidateTimeInMinutes: number) : string | null {
    try {
        let fromLocalStorage = localStorage.getItem(key);
        if (!fromLocalStorage) {
            return null;
        }

        let accessTokenObject = JSON.parse(fromLocalStorage);
        let oneMinInMS: number = 60 * 1000;

        // If the existing token is with in 20 mins limit then return existing token.
        let currentDate = new Date();
        let tokenDate = new Date(accessTokenObject.timestamp);
        let isTokenInTimeRange = (Math.abs(currentDate.getTime() - tokenDate.getTime()) / oneMinInMS) < cacheInvalidateTimeInMinutes;
        if (isTokenInTimeRange) {
            return accessTokenObject.data;
        }

        return null;
    }
    catch (e) {
        return null
    }
}

export function setCachedState(key: string, data: string) {
    try {
        if (!key) {
            return;
        }

        let storageValue: ITokenData = {
            data: data,
            timestamp: new Date()
        };
        localStorage.setItem(key, JSON.stringify(storageValue));
    }
    catch (e) {
        console.log(e);
    }
}

class ITokenData {
    timestamp: Date;
    data: string;
}
